const getApiURL = () => {
  const currentHref = window.location.href;
  const currentPath = window.location.pathname;
  const currentLocation = currentHref.replace(currentPath, "");

  if (currentLocation.includes("localhost")) {
    return process.env.REACT_APP_API_URL;
  } else {
    return "/api";
  }
};

export const API_URL = getApiURL();
